import axios from "axios";
import { Token } from "../urlParams";
import { REACT_APP_USER_API_URL } from "../../envVariables";

export interface entryptedData {
  ticketId: string,
  markedPositions: [number, number][],
  markedPatternName: string,
  calledBalls: (number | string)[]
}
export const claimPattern = async (entryptedData: entryptedData) => {
  try {
    const response = await axios.post(`${REACT_APP_USER_API_URL}lottery/claim-pattern`, entryptedData, {
      headers: {
        'Authorization': `AccessToken=${Token}`,
        'Content-Type': 'application/json',
      }
    });

    return response.data
  } catch (err) {
    console.log('getting error from claim pattern:', err)
  }
}